import Card from "../Reusable/Card";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { ResponsiveBar } from "@nivo/bar";
import { useNavigate } from "react-router-dom";
import RoleIcon from "../../Icons/RoleIcon";
import UsersIcon from "../../Icons/UsersIcon";
const Overview = (props: any) => {
  const { data, graphTheme, salesData, themeColor } = props;
  const navigate = useNavigate();
  const handleNavigate = (pathname: any) => {
    navigate(pathname);
  };
  // console.log(data)
  return (
    <>
      <div className={tw`grid grid-cols-5 gap-x-4 my-2`}>
        <Card
          title="Total User"
          Icon={<UsersIcon color={"var(--primary)"} />}
          onClick={() => window.location.replace("/user-role/users/")}
        >
          <div> {data?.total_users || 0}</div>
        </Card>
        <Card
          title="Active User"
          Icon={<UsersIcon color={"var(--primary)"} />}
          onClick={() =>
            window.location.replace("/user-role/users/?is_active=true")
          }
        >
          <>
            <div> {data?.total_active_user || 0}</div>
          </>
        </Card>
        <Card
          title="Inactive User"
          Icon={<UsersIcon color={"var(--primary)"} />}
          onClick={() =>
            window.location.replace("/user-role/users/?is_active=false")
          }
        >
          <>
            <div> {data?.total_inactive_user || 0}</div>
          </>
        </Card>
        <Card
          Icon={<RoleIcon color={"var(--primary)"} />}
          title="Roles"
          onClick={() => window.location.replace("/user-role/roles")}
        >
          <div> {data?.total_roles || 0}</div>
        </Card>
      </div>
      <Card title="Statistics">
        <div className={tw`h-[600px]`}>
          <ResponsiveBar
            data={salesData}
            keys={["count"]}
            indexBy="day"
            margin={{ top: 20, right: 130, bottom: 80, left: 80 }}
            padding={0.3}
            valueScale={{ type: "linear" }}
            indexScale={{ type: "band", round: true }}
            theme={graphTheme}
            colors={[themeColor]}
            axisBottom={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: "Day of the Week",
              legendPosition: "middle",
              legendOffset: 50,
            }}
            axisLeft={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: "Login",
              legendPosition: "middle",
              legendOffset: -60,
            }}
            labelSkipWidth={12}
            labelSkipHeight={12}
            legends={[
              {
                dataFrom: "keys",
                anchor: "bottom-right",
                direction: "column",
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: "left-to-right",
                itemOpacity: 0.85,
                symbolSize: 20,
                itemTextColor: "var(--primary)",
                effects: [
                  {
                    on: "hover",
                    style: {
                      itemOpacity: 1,
                    },
                  },
                ],
              },
            ]}
            animate={true}
          />
        </div>
      </Card>
    </>
  );
};

export default Overview;
